<div class="flex flex-col flex-auto min-w-0 overflow-hidden">
  <div class="flex-auto relative">
    <div class="absolute inset-0 flex flex-col min-w-0">
      <mat-drawer-container hasBackdrop="false" class="flex-auto h-full bg-card dark:bg-transparent">
        <!-- Drawer for detailed view -->
        <mat-drawer
          (openedChange)="drawerOpenedChange($event)"
          class="detail-content dark:bg-gray-900"
          [mode]="drawerMode"
          [opened]="false"
          [position]="'end'"
          [disableClose]="true"
          #matDrawer
        >
          <div class="w-full h-full flex flex-col">
            <router-outlet></router-outlet>
          </div>
        </mat-drawer>

        <mat-drawer-content>
          <div class="flex flex-col flex-auto h-full overflow-hidden">
            <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-4 pl-4 pr-4">
              <div class="flex-1 min-w-0">
                <div [formGroup]="searchForm" class="flex flex-col flex-auto gap-3">
                  <div class="flex flex-row items-center">
                    <div class="flex flex-row flex-auto justify-end p-4 gap-4">
                      <mat-form-field
                        class="w-full lg:w-55 fuse-mat-no-subscript fuse-mat-rounded-sm fuse-mat-dense fuse-search-box has-border fuse-mat-float-label-always"
                        appearance="fill"
                        floatLabel="always"
                      >
                        <mat-icon matPrefix class="icon-size-5 text-theme-gray">search</mat-icon>
                        <mat-icon *ngIf="masterSearchControl.value" matSuffix class="icon-size-5 text-theme-dark" (click)="masterSearchControl.setValue('')"
                          >clear</mat-icon
                        >
                        <input #searchInput type="text" matInput [formControl]="masterSearchControl" />
                      </mat-form-field>
                      <!-- <button mat-button [class.filter-btn]="filterDrawer?.opened" (click)="filterDrawer.toggle(); masterSearchControl.setValue('')">
                        <mat-icon [ngClass]="filterDrawer?.opened ? 'text-primary' : 'text-theme-gray'" svgIcon="slider"></mat-icon>
                        <span class="ml-1" [ngClass]="filterDrawer?.opened ? 'text-primary' : 'text-theme-dark'">Filter</span>
                      </button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mx-4 border border-b-0 border-theme-gray-border border-solid flex flex-col flex-auto overflow-hidden">
              <div class="relative flex flex-col flex-auto overflow-auto">
                <mat-drawer-container class="h-full">
                  <!-- <mat-drawer #filterDrawer mode="side">
                    <div class="w-full h-full flex flex-col overflow-hidden">
                      <div [formGroup]="searchForm" class="flex flex-auto flex-col p-4 gap-4 overflow-y-auto">
                        <mat-form-field class="w-full lg:w-64" appearance="fill">
                          <mat-label>Report Name</mat-label>
                          <input type="text" matInput formControlName="name" />
                        </mat-form-field>

                        <mat-form-field class="w-full lg:w-64" appearance="fill">
                          <mat-label>Created By</mat-label>
                          <input type="text" matInput formControlName="createdBy" />
                        </mat-form-field>

                        <mat-form-field class="w-full lg:w-64" appearance="fill">
                          <mat-label>Created On</mat-label>
                          <mat-date-range-input [rangePicker]="pickerDate">
                            <input matStartDate formControlName="createdAtFrom" placeholder="Start date" />
                            <input matEndDate formControlName="createdAtTo" placeholder="End date" />
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                          <mat-date-range-picker #pickerDate></mat-date-range-picker>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-row items-center justify-end p-2 gap-2">
                        <button mat-stroked-button (click)="filterDrawer.close()">Close</button>
                        <button mat-flat-button color="primary" (click)="reset()">Reset</button>
                      </div>
                    </div>
                  </mat-drawer> -->

                  <mat-table
                    class="stretch-table"
                    [class.detail-mode]="isDrawerOpened"
                    [dataSource]="
                      items
                        | paginate
                          : {
                              id: paginationControl.id,
                              itemsPerPage: searchForm.get('limit')?.value,
                              currentPage: searchForm.get('page')?.value,
                              totalItems: totalItem
                            }
                    "
                    [trackBy]="identify"
                  >
                    <ng-container matColumnDef="sn" sticky>
                      <mat-header-cell *matHeaderCellDef> SN </mat-header-cell>
                      <mat-cell *matCellDef="let row; let i = index">
                        <span> {{ (searchForm.get('page')?.value - 1) * searchForm.get('limit')?.value + i + 1 }}</span>
                      </mat-cell>
                    </ng-container>

                    <ng-container *ngFor="let col of columns; let isLastCol = last; let isFirstCol = first" [matColumnDef]="col.columnDef">
                      <mat-header-cell *matHeaderCellDef> {{ col.header }} </mat-header-cell>
                      <mat-cell *matCellDef="let item; let i = index">
                        <div class="whitespace-pre-line" [matTooltip]="col.cell(item)">{{ col.cell(item) }}</div>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="action" stickyEnd>
                      <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
                      <mat-cell *matCellDef="let item">
                        <red-table-action-group [item]="item" [actions]="buttons" (actionClick)="actionClick($event, item)"> </red-table-action-group>
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

                    <mat-row
                      class="highlight-row-hover"
                      *matRowDef="let row; columns: displayedColumns"
                      [routerLink]="[row.id]"
                      class="highlight-row-hover"
                      routerLinkActive="row-actived"
                      queryParamsHandling="merge"
                    >
                    </mat-row>
                  </mat-table>
                  <ng-template [redLoadingBox]="isLoading"></ng-template>
                </mat-drawer-container>
              </div>
              <red-pagination
                #paginationControl
                [hidePageSize]="isDrawerOpened"
                [maxSize]="9"
                [itemsPerPage]="searchForm.get('limit')?.value"
                [responsive]="true"
                (pageChange)="onChangePage($event)"
                (itemsPerPageChange)="onItemsPerPageChange($event)"
                previousLabel="Previous"
                nextLabel="Next"
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"
                screenReaderCurrentLabel="You're on page"
              >
              </red-pagination>
            </div>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  </div>
</div>
